module.exports = __webpack_public_path__ + "static/vmno-streaming-now-tallyman.v1-click2sms/files/72385a129f5799150f3a1307b546f470.mp4";